// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"TestPage_wrap_div__1Vebz","back_img":"TestPage_back_img__7O3kM","page_break":"TestPage_page_break__8wui4"};